/**
 * How strictly the template wizard treats placeholder fields before generating output.
 *
 * @typedef {'optional' | 'requireAllReplaced'} TemplateFieldPolicy
 */

export const TEMPLATE_FIELD_POLICY = Object.freeze({
  /** Empty values keep tokens; defaults match template text. Product Development style flow. */
  OPTIONAL: 'optional',
  /**
   * Every detected placeholder must be edited to a value that differs from its default token
   * (e.g. user must not leave `{COMPANY_NAME}` as-is). Standalone /create-from-template style flow.
   */
  REQUIRE_ALL_REPLACED: 'requireAllReplaced',
});
